<script>

    import { Pie } from 'vue-chartjs'

    export default {

        name : 'diplome-pie-chart',

        extends: Pie,

        data: function () {
            return {

                diplomes : [
                    {id: "secondaire", text: "Secondaire"},
                    {id: "dec", text: "DEC"},
                    {id: "certificat", text: "Certificat"},
                    {id: "baccalaureat", text: "Baccalauréat"},
                    {id: "maitrise", text: "Maîtrise"},
                    {id: "doctorat", text: "Doctorat"},
                ]

            }
        },

        props: ['chartData'],


        mounted() {

            let default_colors = ['#3366CC','#DC3912','#FF9900','#109618','#990099','#3B3EAC','#0099C6','#DD4477','#66AA00','#B82E2E','#316395','#994499','#22AA99','#AAAA11','#6633CC','#E67300','#8B0707','#329262','#5574A6','#3B3EAC']


            let labels = [];
            let dataset = {
                backgroundColor : [],
                data : []
            };
            this.diplomes.forEach((diplome, idx) => {
                if(this.chartData[diplome.id])
                {
                    labels.push(diplome.text);
                    dataset.data.push(this.chartData[diplome.id]);
                    dataset.backgroundColor.push(default_colors[idx]);
                }
            });

            let data = { datasets : [dataset], labels : labels };
            this.renderChart(data)
        }

    }


</script>


